import React from 'react';
import { Clock, Star } from 'lucide-react';
const testimonials = [{
  stars: 5,
  text: "I thought I 'knew' Charlie Kirk from clips. This bundle gave me the full story in order. I finished it in two nights and shared it with my brother immediately.",
  name: 'Robert M.',
  location: 'Dallas, TX',
  tag: 'Verified Purchase'
}, {
  stars: 5,
  text: "The timeline + quotes bonus is gold. It's the kind of thing you save—because it captures a moment in American culture that people will pretend never happened.",
  name: 'James T.',
  location: 'Tampa, FL',
  tag: 'Verified Purchase'
}, {
  stars: 5,
  text: 'I bought it for my husband and he listened to it on his commute. He said it was the first time he understood the why behind Charlie—not just the headlines.',
  name: 'Sarah K.',
  location: 'Columbus, OH',
  tag: 'Verified Purchase'
}];
export function ProofSection() {
  return <section className="bg-navy text-white py-16 px-4" data-id="element-347">
      <div className="max-w-3xl mx-auto text-center" data-id="element-348">
        <div className="inline-flex items-center justify-center gap-2 bg-navy-light px-4 py-2 rounded-full mb-6 border border-blue-800" data-id="element-349">
          <Clock className="text-gold" size={20} data-id="element-350" />
          <span className="font-bold tracking-wide text-sm uppercase" data-id="element-351">
            What Changes In 7 Days
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight" data-id="element-352">
          Go From "I've Seen Clips" To "I Actually Know The Story."
        </h2>

        <p className="text-blue-300 text-lg mb-10 max-w-2xl mx-auto" data-id="element-353">
          In less than a week, you'll have the story in order—timeline, turning
          points, and context—in a bundle you can keep and share.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-354">
          {testimonials.map((t, i) => <div key={i} className="bg-navy-light border border-blue-800 rounded-xl p-6 text-left shadow-lg flex flex-col" data-id="element-355">
              <div className="flex gap-1 mb-3" data-id="element-356">
                {[...Array(t.stars)].map((_, s) => <Star key={s} size={14} fill="currentColor" className="text-gold" data-id="element-357" />)}
              </div>
              <p className="text-gray-300 text-sm leading-relaxed flex-1 italic mb-4" data-id="element-358">
                "{t.text}"
              </p>
              <div className="border-t border-blue-900 pt-3" data-id="element-359">
                <p className="font-bold text-white text-sm" data-id="element-360">{t.name}</p>
                <p className="text-blue-400 text-xs" data-id="element-361">{t.location}</p>
                <span className="inline-block mt-1 bg-green-900/50 text-green-400 text-xs px-2 py-0.5 rounded-full border border-green-800" data-id="element-362">
                  ✓ {t.tag}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}